<template>
  <v-layout align-center justify-center fill-height style="background: white;">
    <!-- DIalog para incluir o password para entrar -->
    <v-dialog v-model="dialogPassword" @keydown.enter="confirmPassword()" @keydown.esc="cancelPassword()" persistent max-width="500" scrollable>
      <v-card>
      <v-card-title
          class="headline grey lighten-2"
          primary-title
      >
      Digite a senha para acessar os arquivos
      </v-card-title>
      <v-text-field :disable="loadingPassword" :loading="loadingPassword" prepend-icon="lock" label="Senha" v-model="password" :type="number" mask="######"/>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat color="primary" :loading="loadingPassword" @click.native="confirmPassword()">{{'Confirmar'}}</v-btn>
          <v-btn class="mx-0" flat :loading="loadingPassword" @click.native="cancelPassword()">{{'Cancelar'}}</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12 sm10 md8 lg5>
      <!-- // Card inicial para mostrar o carregamento do fomrulário -->
      <v-card v-if="loadingPassword" class="pa-4 pb-0 elevation-7 rounded-card">
        <v-progress-linear indeterminate></v-progress-linear>
        <a href="https://www.illis.com.br" target="_blank" style="text-decoration:none!important;color:#7a7d7e;">
          <v-layout align-center justify-center row fill-height>
              <span >powered by</span>&nbsp;<img width="45" height="30" src="https://illis.com.br/wp-content/uploads/2021/08/Ativo-1-150x100.png">
          </v-layout>
        </a>
      </v-card>
      <!-- // Card caso o Registro não exista -->
      <v-card v-else-if="taskNotFound" class="pa-4 pb-0 elevation-7 rounded-card">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center">
              <span class="headline">Registro não encontrado</span>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <!-- // Card que mostra o conteudo do fomulário -->
      <v-card v-else class="pa-4 pb-0 elevation-7 rounded-card">
        <v-layout align-center justify-center row wrap>
        </v-layout>
        <v-card-text>
          <v-form ref="form_form">
            <!--//-------------------------campo FILE---------------------->
            <v-flex v-for="(field, index) in customFieldsFiles" :key="index">
              <v-form :ref="'cfa_ '+ index + '_form'">
                <div style="padding-left:7px">
                  <p-file blackLabel :id="'cfa_' + index" :label="field['title'] ? field['title'] : 'campo'" :custom_field_id="field['id']" @addFiles="(val)=>addFiles(val, field)" :custom_field="field" :canDelete="false" :canAdd="false" :password="password" :tasktemplate_automation_id="$route.params.id">
                  </p-file>
                </div>
              </v-form>
            </v-flex>
          </v-form>
        </v-card-text>
        <a href="https://www.illis.com.br" target="_blank" style="text-decoration:none!important;color:#7a7d7e;">
          <v-layout align-center justify-center row fill-height>
              <span >powered by</span>&nbsp;<img width="45" height="30" src="https://illis.com.br/wp-content/uploads/2021/08/Ativo-1-150x100.png">
          </v-layout>
        </a>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  /* eslint-disable eqeqeq, no-useless-escape */
  import PFile from './PFile'
  import methodTaskSocket from './../../mixin/methodTaskSocket'
  import rules from './../../mixin/rules'
  export default ({
    mixins: [methodTaskSocket, rules],
    components: {PFile},
    data: () => ({
      customFieldsFiles: [],
      password: '',
      dialogPassword: true,
      loadingPassword: false,
      taskNotFound: false
    }),
    methods: {
      confirmPassword () {
        this.loadingPassword = true
        this.$http.put(`api/task_link_view/${this.$route.params.id}`, {password: this.password}).then((res) => {
          this.customFieldsFiles = res.body
          this.loadingPassword = false
          this.dialogPassword = false
        }, err => {
          console.log(err)
          this.dialogPassword = false
          if (err.body.message === 'wrongPassword') {
            this.$store.commit('snackbar/change_values', {text: 'Senha incorreta.', timeout: 10000, color: 'warning', dialog: true})
            this.dialogPassword = true
          } else if (err.body.message === 'notFoundPassword' || err.body.message === 'notFoundtask') {
            this.$store.commit('snackbar/change_values', {text: 'Tarefa não encontrada.', timeout: 10000, color: 'warning', dialog: true})
            this.taskNotFound = true
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível acessar o registro, reporte o erro.', color: 'error', dialog: true})
            this.taskNotFound = true
          }
          this.loadingPassword = false
        })
      },
      cancelPassword () {
        this.taskNotFound = true
        this.loadingPassword = false
        this.dialogPassword = false
      }
    }
  })
</script>

<style scoped>
  .rounded-card{
    border-radius:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/TaskLinkView.vue